<div class="filtersContainer">
    <lib-slide-toggle
        class="filter"
        label="Starred"
        [(checked)]="filterValue.onlyFavorites"
        (checkedChange)="onFiltersChanged()"
    ></lib-slide-toggle>
    @if (name === 'User') {
        <lib-slide-toggle
            class="filter"
            label="Scheduled"
            [(checked)]="filterValue.onlyScheduled"
            (checkedChange)="onFiltersChanged()"
        ></lib-slide-toggle>
    }
    <lib-search-input
        class="filter"
        [placeholderText]="'Report Name'"
        [(text)]="filterValue.searchText"
        (textChange)="onFiltersChanged()"
    ></lib-search-input>
</div>

@if (groupedList.length !== 0) {
    <div class="listContainer">
        @for (reportGroup of groupedList; track reportGroup) {
            <app-titled-list-group
                [title]="reportGroup.title"
                [items]="reportGroup.items"
                (isFavoriteChange)="onToggleFavorite($event)"
                (removeItemRequest)="onRemoveItem($event)"
            ></app-titled-list-group>
        }
    </div>
}

@if (groupedList.length === 0) {
    <lib-no-data [iconName]="'emptyData'" [title]="'No Reports available'"></lib-no-data>
}
